import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '../../../Common/_hooks/useAppDispatch'
import { ProductItem } from '../../../UserData/_stores/UserCartStore'
import { type StoreItemStore } from '../../../UserData/_stores/Store/StoreItemStore'
import { type UserProductDesignStore } from '../../../UserData/_stores/UserProductDesignStore'
import { UpdateCartItem } from '../../../UserData/_actions/UserCartActions'
import SyncProductDialog from '../Products/SyncProductDialog'

interface Props {
  idCart: number
  storeItem: StoreItemStore
  item?: ProductItem
  opened: boolean
  onClose: () => void
}

export default function SyncItemDialog(props: Props) {
  const dispatch = useAppDispatch()

  const cartItem = useMemo(() => {
    if (!props.item?.get('id_product_design') || !props.item?.get('product_id')) {
      return new ProductItem({
        id: props.item?.get('id') ?? 0,
        quantity: props.storeItem.get('quantity')
      })
    }

    return props.item
  }, [props.item, props.storeItem])

  const onConfirm = useCallback((productDesign: UserProductDesignStore, listOptions: Immutable.Map<number, number>, listBrandingOptions: Immutable.Map<number, number>) => {
    if (!productDesign) return

    const fd = new FormData()

    fd.append('cart_id', String(props.idCart))

    if (cartItem.get('id') > 0) {
      fd.append('id', String(cartItem.get('id')))
    }

    fd.append('id_store_item', String(props.storeItem.get('id')))

    fd.append('fields[]', 'item_id')
    fd.append('fields[]', 'product_id')
    fd.append('fields[]', 'options')
    fd.append('fields[]', 'quantity')

    fd.append('type', 'product')
    fd.append('item_id', String(productDesign.get('id_product_design')))
    fd.append('product_id', String(productDesign.get('id_product')))
    fd.append('quantity', String(cartItem.get('quantity')))

    listOptions.forEach((optionId, optionTypeId) => {
      fd.append('options[]', String(optionId))
    })

    listBrandingOptions.forEach((brandingOptionId, optionId) => {
      fd.append('brandingOptions[' + optionId + ']', String(brandingOptionId))
    })

    dispatch(UpdateCartItem(fd).set({
      onSuccess: () => {
        props.onClose()
      }
    }))
  }, [cartItem, props.idCart])

  return <SyncProductDialog
    opened={props.opened}
    onClose={props.onClose}
    onConfirm={onConfirm}
    productDesignId={props.item?.get('id_product_design')}
    item={cartItem}
  />
}
